import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  {
    class: 'ineligible',
    field: 'peBelugaFollowup_ineligible',
    label: "We're sorry you don't qualify",
    subLabel: "We're not able to prescribe for you today",
    extras: { sendToBeluga: false },
    type: 'info',
    isLast: true,
    answer: {}
  },
  {
    field: 'peBelugaFollowup_complete',
    isLast: true,
    label: `Thank you for completing this questionnaire, please select "Finish" to submit`,
    extras: { sendToBeluga: false },
    type: 'info',
    answer: {}
  },
  {
    label: 'What is your height in feet and inches?',
    field: 'peBelugaFollowup_height',
    type: 'info',
    answer: {
      name: 'peBelugaFollowup_height',
      type: 'text',
      placeholder: 'Feet and inches'
    }
  },
  {
    label: 'What is your weight in pounds?',
    field: 'peBelugaFollowup_weight',
    type: 'info',
    answer: {
      name: 'peBelugaFollowup_weight',
      type: 'text',
      placeholder: 'Pounds'
    }
  },
  {
    label:
      'Have there been any health changes, medication changes, ED visits or hospitalizations since your last check-in?',
    field: 'peBelugaFollowup_healthChanges',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'peBelugaFollowup_healthChanges_yes',
          value: 'Yes'
        },
        {
          key: 'peBelugaFollowup_healthChanges_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'Please tell us more about the changes in your health',
    field: 'peBelugaFollowup_healthChanges_details',
    type: 'info',
    answer: {
      name: 'peBelugaFollowup_healthChanges_details',
      type: 'text',
      placeholder: 'Health changes details'
    }
  },
  {
    label: 'How are you doing on the current medication?',
    field: 'peBelugaFollowup_medicationStatus',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'peBelugaFollowup_medicationStatus_well',
          value: 'Well'
        },
        {
          key: 'peBelugaFollowup_medicationStatus_notWell',
          value: 'Not well'
        }
      ]
    }
  },
  {
    label: 'Please tell us more about what you are experiencing',
    field: 'peBelugaFollowup_medicationStatus_details',
    type: 'info',
    answer: {
      name: 'peBelugaFollowup_medicationStatus_details',
      type: 'text',
      placeholder: 'Medication experience details'
    }
  },
  {
    label: 'Have you had any side effects from the current medication?',
    field: 'peBelugaFollowup_sideEffects',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'peBelugaFollowup_sideEffects_yes',
          value: 'Yes'
        },
        {
          key: 'peBelugaFollowup_sideEffects_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'Please tell us more about the side effects you are experiencing',
    field: 'peBelugaFollowup_sideEffects_details',
    type: 'info',
    answer: {
      name: 'peBelugaFollowup_sideEffects_details',
      type: 'text',
      placeholder: 'Side effects details'
    }
  },
  {
    label: 'What other information or questions do you have for the doctor?',
    field: 'peBelugaFollowup_otherInformation',
    type: 'info',
    answer: {
      name: 'peBelugaFollowup_otherInformation',
      type: 'text',
      placeholder: 'Additional information or questions'
    }
  },
  {
    label: 'Consent (Truthfulness)',
    educationalSlide: `Please attest to the following confirming that all information you have provided to us is true and complete.

Consent: I verify that I am the patient and that I have answered the questions asked in this intake form. I confirm that I have reviewed and understood all the questions asked of me. I attest that the answers and information I have provided in this questionnaire is true and complete to the best of my knowledge. I understand that it is critical to my health to share complete health information with my doctor. I will not hold the doctor or affiliated medical practice responsible for any oversights or omissions, whether intentional or not, in the information that I provided.`,
    field: 'peBelugaFollowup_truthConsent',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'peBelugaFollowup_truthConsent_disagree',
          class: 'option-decline',
          value:
            'I have read the above information and I do not wish to continue'
        },
        {
          key: 'peBelugaFollowup_truthConsent_agree',
          class: 'option-consent',
          value:
            'I have read the above information and I do consent and wish to move forward'
        }
      ]
    }
  },
  {
    label: 'Consent (Premature Ejaculation)',
    educationalSlide: `This consent form provides information about the use of Phosphodiesterase-5 inhibitors (PDE5i), Selective Serotonin Reuptake Inhibitors (SSRIs), or Selective Serotonin and Norepinephrine Reuptake Inhibitors (SNRI) as a treatment for premature ejaculation (PE). Please read the information carefully.

Purpose of Treatment

PDE5 inhibitors (e.g., Sildenafil, Tadalafil) and SSRIs and SNRIs (e.g., Sertraline, Fluoxetine) are medications that may help delay ejaculation and improve sexual satisfaction. These medications may be prescribed alone or in combination with other treatments or behavioral therapies. It is important to note that the use of PDE5 inhibitors and SSRI/SNRIs for the treatment of premature ejaculation is considered an off-label use.

What Is Off-Label Use?

Off-label use means that the medication is being prescribed for a condition or purpose that is not specifically approved by the Food and Drug Administration (FDA). This is a common practice in medical care when evidence supports the effectiveness of a treatment for an unapproved use.

Potential Benefits
- Increased control over ejaculation timing
- Improved sexual performance and satisfaction
- Reduced stress and anxiety related to premature ejaculation

Potential Risks and Side Effects

PDE5 Inhibitors
Common side effects include headache, flushing, nasal congestion, dizziness, back pain, or upset stomach. Rare but serious side effects include vision or hearing loss, prolonged erections (priapism), or cardiovascular complications.

SSRIs
Common side effects include nausea, fatigue, dry mouth, diarrhea, or decreased libido. Rare but serious side effects include serotonin syndrome (a potentially life-threatening condition), changes in mood or behavior, or increased risk of bleeding.

Precautions
PDE5 inhibitors are not recommended for patients taking nitrates, alpha-blockers, or certain blood pressure medications due to the risk of severe hypotension. SSRIs may interact with other medications, including other antidepressants, blood thinners, or certain pain relievers. Inform your healthcare provider about all medications, supplements, and medical conditions before starting treatment.

Selective Serotonin Reuptake Inhibitors (SSRIs) are widely used to treat various conditions. However, studies have shown that SSRIs may be associated with an increased risk of suicidal thoughts or behaviors, particularly in children, adolescents, and young adults during the initial weeks of treatment or after a dose change. While this risk is rare, it is important for patients and caregivers to monitor for any changes in mood, behavior, or thoughts of self-harm and report them to a healthcare provider immediately. Regular follow-up is crucial to ensure the safe and effective use of SSRIs.

Alternative Treatments
- Behavioral therapies (e.g., start-stop technique, pelvic floor exercises)
- Topical anesthetic sprays or creams
- Counseling or psychotherapy
- Condom use

Patient Responsibilities
- Follow the prescribed dosage and instructions
- Notify your healthcare provider immediately if you experience any severe side effects or adverse reactions
- Do not use these medications in combination with other treatments or substances unless approved by your provider

I understand the potential benefits, risks, and side effects of this medication. I have been informed about alternative treatment options. I agree to inform my healthcare provider of any side effects or adverse reactions I may experience. I understand that this consent is voluntary and that I can withdraw from treatment at any time.

By selecting below, I consent to the use of this medication for the treatment of my symptoms`,

    field: 'peBelugaFollowup_treatmentConsent',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'peBelugaFollowup_treatmentConsent_disagree',
          class: 'option-decline',
          value: 'I have read the information and I DO NOT wish to proceed'
        },
        {
          key: 'peBelugaFollowup_treatmentConsent_agree',
          class: 'option-consent',
          value:
            'I have read and understand the information and I wish to proceed'
        }
      ]
    }
  }
];

export default questionsModels;
